import { render, staticRenderFns } from "./PageManageWidgets.vue?vue&type=template&id=3d2e0d88"
import script from "./PageManageWidgets.vue?vue&type=script&lang=js"
export * from "./PageManageWidgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports